import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { adminAPI } from '../services/api';
import { toast } from 'sonner';
import { Activity, RefreshCw, AlertTriangle } from 'lucide-react';

const AdminObservabilityPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [source, setSource] = useState('local');

  const loadLogs = async (selectedSource = source) => {
    setLoading(true);
    try {
      const response = await adminAPI.getObservabilityLogs({ min_status_code: 300, limit: 120, source: selectedSource });
      setLogs(response.data.items || []);
    } catch (error) {
      const detail = error?.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Erro ao carregar logs de observabilidade');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <div className="space-y-6" data-testid="admin-observability-page">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold text-white flex items-center gap-3">
              <Activity className="text-white" /> Observabilidade
            </h1>
            <p className="text-neutral-400 mt-1">Logs HTTP com status acima de 300 e alertas para 400/500.</p>
          </div>
          <div className="flex gap-2">
            <Button variant={source === 'local' ? 'default' : 'outline'} onClick={() => { setSource('local'); loadLogs('local'); }}>
              Local
            </Button>
            <Button variant={source === 'gcp' ? 'default' : 'outline'} onClick={() => { setSource('gcp'); loadLogs('gcp'); }}>
              GCP
            </Button>
            <Button className="btn-primary" onClick={() => loadLogs()}>
              <RefreshCw size={16} className="mr-2" /> Atualizar
            </Button>
          </div>
        </div>

        <Card className="glass-card border-white/10">
          <CardHeader>
            <CardTitle className="text-white">Eventos ({logs.length})</CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className="flex items-center justify-center h-40"><div className="spinner" /></div>
            ) : logs.length === 0 ? (
              <div className="text-neutral-400">Nenhum evento encontrado.</div>
            ) : (
              <div className="space-y-3 max-h-[65vh] overflow-auto pr-1">
                {logs.map((log, idx) => (
                  <div key={`${log.timestamp}-${idx}`} className="p-3 rounded-md bg-black/20 border border-white/10">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-white font-semibold">{log.level} {log.status_code ? `· HTTP ${log.status_code}` : ''}</span>
                      <span className="text-neutral-400">{log.timestamp ? new Date(log.timestamp).toLocaleString('pt-BR') : '-'}</span>
                    </div>
                    <div className="text-neutral-300 mt-1 text-sm">{log.message}</div>
                    <div className="text-xs text-neutral-500 mt-1">{log.logger || 'n/a'}</div>
                    {(log.status_code === 400 || log.status_code === 500) && (
                      <div className="text-amber-400 text-xs mt-2 flex items-center gap-1"><AlertTriangle size={14} /> Alerta disparado para este código.</div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default AdminObservabilityPage;
